import { MenuItem } from "primereact/menuitem";
import { routeClass } from "../../../routes/routePreload";
import { ALERT_LIST_PATH } from "../../../Pages/Alert/alertConstants";
import { PROJECT_LIST_PATH } from "../../../Pages/Project/projectConstants";
import { canViewAlerts, canViewProcessflows, canViewKnowledgeBase, canViewProjects } from "../../../Util/permissionUtil";
import { MARKETPLACE_PERMISSIONS, MARKETPLACE_ROUTE } from "../../../Pages/Marketplace/marketplaceConstants";
import { PROCESSFLOW_TYPE_OBJECTIVE, PROCESSFLOW_TYPE_READINESS } from "../../../Pages/Processflow/processflowConstants";
import { ErrorService } from "../../../Services/errorService";
import handleError from "../../../Util/HandleError";

export const getActiveMenusFromPath = (pathname: string): { parent: string | null, child: string | null, subChild?: string } => {
    if (pathname === "/") return { parent: 'items', child: null };
    if (pathname === "/openai") return { parent: 'aiItem', child: null };
    if (pathname === "/ask-ai") return { parent: 'aiItem', child: null };

    if (pathname === "/dashboards") return { parent: 'dashboards', child: null };
    if (pathname.startsWith("/dashboard")) return { parent: 'dashboards', child: null };

    if (pathname === MARKETPLACE_ROUTE || pathname.startsWith(`${MARKETPLACE_ROUTE}/`)) return { parent: 'marketplaceItem', child: null };

    if (pathname === "/management/dashboard-category") return { parent: 'managementItems', child: 'dashboard-category' };
    if (pathname === "/management/customer") return { parent: 'managementItems', child: 'customer' };
    if (pathname === "/management/user") return { parent: 'managementItems', child: 'user' };
    if (pathname === "/management/role") return { parent: 'managementItems', child: 'role' };
    if (pathname === "/management/access" || pathname.startsWith("/management/access/")) {
        return { parent: 'accessItem', child: null };
    }
    if (pathname === "/management/customer") return { parent: 'accessItem', child: null };
    if (pathname === "/management/user") return { parent: 'accessItem', child: null };
    if (pathname === "/management/role") return { parent: 'accessItem', child: null };
    if (pathname === "/management/messageEvent") return { parent: 'systemValueItems', child: 'eventDetails', subChild: 'messageEvent' }
    if (pathname === "/management/recipient") return { parent: 'systemValueItems', child: 'eventDetails', subChild: 'recipient' }

	if (pathname === ALERT_LIST_PATH || pathname.startsWith(`${ALERT_LIST_PATH}/`)) return { parent: 'alertsItem', child: null };
    if (pathname === PROJECT_LIST_PATH || pathname.startsWith(`${PROJECT_LIST_PATH}/`)) return { parent: 'projectsItem', child: null };
    if (pathname === "/processflows" || pathname.startsWith("/processflows/")) return { parent: 'processflowItem', child: null };
    if (pathname === "/objectives" || pathname.startsWith("/objectives/")) return { parent: 'objectiveItem', child: null };
    if (pathname === "/knowledge-base" || pathname.startsWith("/knowledge-base/")) return { parent: 'knowledgeBaseItem', child: null };
    if (pathname === "/settings" || pathname.startsWith("/settings/")) return { parent: "settingsItem", child: null };
    if (pathname === "/profile/settings") return { parent: "settingsItem", child: null };
	if (pathname === "/data-hero") return { parent: 'dataHeroItem', child: null };

    if (pathname === "/management/dashboard-category") return { parent: 'systemValueItems', child: 'dashboard-category' };

    if (pathname === "/system/cache") return { parent: 'systemValueItems', child: 'cache' };
    if (pathname === "/system/dashly-email") return { parent: 'systemValueItems', child: 'dashly-email' };
    if (pathname === "/system/generic-select-item") return { parent: 'systemValueItems', child: 'generic-select-item' };
    if (pathname === "/system/external-user") return { parent: 'systemValueItems', child: 'external-user' };
    if (pathname === "/system/metric") return { parent: 'systemValueItems', child: 'metric' };
    if (pathname === "/system/metric-view") return { parent: 'systemValueItems', child: 'metric-views' };
    if (pathname === "/system/dataservice") return { parent: 'systemValueItems', child: 'dataservice' };

    if (pathname.startsWith("/management/")) return { parent: null, child: null };
    if (pathname.startsWith("/system/")) return { parent: 'systemValueItems', child: null };
    if (pathname.startsWith("/management/dashboard")) return { parent: 'dashboards', child: null };

    return { parent: null, child: null };
};

// menu items :
export const items = (
    navigate: (path: string) => void,
    isMobile: boolean,
    closeDialog: (open: boolean) => void,
    activeParent: string | null

): MenuItem[] => [
        {
            className: `menu-item ${activeParent === "items" ? "active" : ""} ${routeClass("/")}`,
            icon: "pi pi-home",
            command: () => {
                navigate("/");
                if (isMobile) {
                    closeDialog(false);
                }
            },
        },
    ];


export const dashboards = (
    navigate: (path: string) => void,
    isMobile: boolean,
    closeDialog: (open: boolean) => void,
    permissions: string[],
    activeParent: string | null

): MenuItem[] => [
        {
            className: `menu-item ${activeParent === "dashboards" ? "active" : ""} ${routeClass("/dashboards")}`,
            icon: 'pi pi-objects-column',
            command: () => {
                navigate("/dashboards");
                if (isMobile) {
                    closeDialog(false);
                }
            },
            visible: permissions.includes("Dashboard.View")
        }
    ];

export const marketplaceItem = (
    navigate: (path: string) => void,
    isMobile: boolean,
    closeDialog: (open: boolean) => void,
    permissions: string[],
    activeParent: string | null,
): MenuItem[] => [
        {
            className: `menu-item ${activeParent === "marketplaceItem" ? "active" : ""} ${routeClass(MARKETPLACE_ROUTE)}`,
            icon: "pi pi-shop",
            command: () => {
                navigate(MARKETPLACE_ROUTE);
                if (isMobile) {
                    closeDialog(false);
                }
            },
            visible: permissions.includes(MARKETPLACE_PERMISSIONS.CONNECT),
        },
    ];

export const aiItem = (
    navigate: (path: string) => void,
    isMobile: boolean,
    closeDialog: (open: boolean) => void,
    permissions: string[],
    activeParent: string | null,

): MenuItem[] => [
        {
            // className: "menu-item",
            className: `menu-item ${activeParent === "aiItem" ? "active" : ""} ${routeClass("/ask-ai")}`,
            icon: "pi pi-sparkles",
            visible: permissions.includes("AskAi.Sidebar"),
            command: () => {
                navigate("/ask-ai");
                if (isMobile) {
                    closeDialog(false);
                }
            },
        },
    ];

export const alertsItem = (
    navigate: (path: string) => void,
    isMobile: boolean,
    closeDialog: (open: boolean) => void,
    permissions: string[],
    activeParent: string | null,
): MenuItem[] => [
        {
            className: `menu-item ${activeParent === "alertsItem" ? "active" : ""} ${routeClass(ALERT_LIST_PATH)}`,
            icon: "pi pi-bell",
            command: () => {
                navigate(ALERT_LIST_PATH);
                if (isMobile) {
                    closeDialog(false);
                }
            },
            visible: canViewAlerts(permissions),
        },
    ];

export const projectsItem = (
    navigate: (path: string) => void,
    isMobile: boolean,
    closeDialog: (open: boolean) => void,
    permissions: string[],
    activeParent: string | null,
): MenuItem[] => [
        {
            className: `menu-item ${activeParent === "projectsItem" ? "active" : ""} ${routeClass(PROJECT_LIST_PATH)}`,
            icon: "pi pi-folder-open",
            command: () => {
                navigate(PROJECT_LIST_PATH);
                if (isMobile) {
                    closeDialog(false);
                }
            },
            visible: canViewProjects(permissions),
        },
    ];

export const processflowItem = (
    navigate: (path: string) => void,
    isMobile: boolean,
    closeDialog: (open: boolean) => void,
    permissions: string[],
    activeParent: string | null,
): MenuItem[] => [
        {
            className: `menu-item ${activeParent === "processflowItem" ? "active" : ""} ${routeClass("/processflows")}`,
            icon: "pi pi-share-alt",
            command: () => {
                navigate("/processflows");
                if (isMobile) {
                    closeDialog(false);
                }
            },
            visible: canViewProcessflows(permissions, PROCESSFLOW_TYPE_READINESS),
        },
    ];

export const objectiveItem = (
    navigate: (path: string) => void,
    isMobile: boolean,
    closeDialog: (open: boolean) => void,
    permissions: string[],
    activeParent: string | null,
): MenuItem[] => [
        {
            className: `menu-item ${activeParent === "objectiveItem" ? "active" : ""} ${routeClass("/objectives")}`,
            icon: "pi pi-gauge",
            command: () => {
                navigate("/objectives");
                if (isMobile) {
                    closeDialog(false);
                }
            },
            visible: canViewProcessflows(permissions, PROCESSFLOW_TYPE_OBJECTIVE),
        },
    ];

export const knowledgeBaseItem = (
    navigate: (path: string) => void,
    isMobile: boolean,
    closeDialog: (open: boolean) => void,
    permissions: string[],
    activeParent: string | null,
): MenuItem[] => [
        {
            className: `menu-item ${activeParent === "knowledgeBaseItem" ? "active" : ""}`,
            icon: "pi pi-book",
            command: () => {
                navigate("/knowledge-base");
                if (isMobile) {
                    closeDialog(false);
                }
            },
            visible: canViewKnowledgeBase(permissions),
        },
    ];

export const settingsItem = (
    navigate: (path: string) => void,
    isMobile: boolean,
    closeDialog: (open: boolean) => void,
    activeParent: string | null,
): MenuItem[] => [
        {
            className: `menu-item ${activeParent === "settingsItem" ? "active" : ""} ${routeClass("/settings")}`,
            icon: "pi pi-cog",
            command: () => {
                navigate("/settings");
                if (isMobile) {
                    closeDialog(false);
                }
            },
            visible: true,
        },
    ];

export const accessItem = (
    navigate: (path: string) => void,
    isMobile: boolean,
    closeDialog: (open: boolean) => void,
    permissions: string[],
    activeParent: string | null,
): MenuItem[] => [
        {
            className: `menu-item ${activeParent === "accessItem" ? "active" : ""} ${routeClass("/management/access")}`,
            icon: "pi pi-shield",
            command: () => {
                navigate("/management/access");
                if (isMobile) {
                    closeDialog(false);
                }
            },
            visible: permissions.includes("Customer.View")
                || permissions.includes("Role.View")
                || permissions.includes("User.View"),
        },
    ];

export const dataHeroItem = (
    navigate: (path: string) => void,
    isMobile: boolean,
    closeDialog: (open: boolean) => void,
    permissions: string[],
    activeParent: string | null,
): MenuItem[] => [
        {
            className: `menu-item ${activeParent === "dataHeroItem" ? "active" : ""} ${routeClass("/data-hero")}`,
            icon: "pi pi-crown",
            command: () => {
                navigate("/data-hero");
                if (isMobile) {
                    closeDialog(false);
                }
            },
            visible: permissions.includes("Data_Hero.View"),
        },
    ];

export const systemValueItems = (
    navigate: (path: string) => void,
    isMobile: boolean,
    closeDialog: (open: boolean) => void,
    permissions: string[],
    t: (key: string) => string,
    activeParent: string | null,
    activeChild: string | null,
    systemValueToggle: boolean,
    toggleSystemValue: () => void
): MenuItem[] => [
        {
            className: `menu-item ${activeParent === "systemValueItems" ? "active" : ""}`,
            icon: "pi pi-database",
            expanded: systemValueToggle,
            command: toggleSystemValue,
            items: [
	            {
		            className: `sub menu-item ${activeChild === "metric" ? "active" : ""} ${routeClass("/system/metric")}`,
		            label: t("system.metrics"),
		            command: () => {
			            navigate("/system/metric");
			            if (isMobile) {
				            closeDialog(false);
			            }
		            },
		            visible: permissions.includes("Metric.View"),
	            },
                {
                    className: `sub menu-item ${activeChild === "metric-views" ? "active" : ""} ${routeClass("/system/metric-view")}`,
                    label: t("system.metric-views"),
                    command: () => {
                        navigate("/system/metric-view");
                        if (isMobile) {
                            closeDialog(false);
                        }
                    },
                    visible: permissions.includes("MetricView.View"),
                },
                {
                    className: "sub menu-item",
                    label: t("trigger.error"),
                    command: () => {
                        closeDialog(false);
                        new ErrorService()
                            .throwError()
                            .catch((error: any) => handleError(error));
                    },
                    visible: false,
                },
	            {
		            className: `sub menu-item ${activeChild === "cache" ? "active" : ""} ${routeClass("/system/cache")}`,
		            label: t("system.cache"),
		            command: () => {
			            navigate("/system/cache");
			            if (isMobile) {
				            closeDialog(false);
			            }
		            },
		            visible: permissions.includes("Cache.View"),
	            },
                {
                    className: `sub menu-item ${activeChild === "dashly-email" ? "active" : ""} ${routeClass("/system/dashly-email")}`,
                    label: t("system.dashly-email"),
                    command: () => {
                        navigate("/system/dashly-email");
                        if (isMobile) {
                            closeDialog(false);
                        }
                    },
                    visible: permissions.includes("DashlyEmail.View"),
                },
                {
                    className: `sub menu-item ${activeChild === "generic-select-item" ? "active" : ""} ${routeClass("/system/generic-select-item")}`,
                    label: t("system.generic-select-item"),
                    command: () => {
                        navigate("/system/generic-select-item");
                        if (isMobile) {
                            closeDialog(false);
                        }
                    },
                    visible: permissions.includes("GenericSelectItem.View"),
                },
                {
                    className: `sub menu-item ${activeChild === "external-user" ? "active" : ""} ${routeClass("/system/external-user")}`,
                    label: t("system.external-user"),
                    command: () => {
                        navigate("/system/external-user");
                        if (isMobile) {
                            closeDialog(false);
                        }
                    },
                    visible: permissions.includes("ExternalUser.View"),
                },
                {
                    className: `sub menu-item ${activeChild === "dataservice" ? "active" : ""} ${routeClass("/system/dataservice")}`,
                    label: t("dataservices"),
                    command: () => {
                        navigate("/system/dataservice");
                        if (isMobile) {
                            closeDialog(false);
                        }
                    },
                    visible: permissions.includes("Dataservice.View"),
                },
	            {
		            className: `sub menu-item ${activeChild === "dashboard-category" ? "active" : ""} ${routeClass("/management/dashboard-category")}`,
		            label: t("management.dashboard-category"),
		            command: () => {
			            navigate("/management/dashboard-category");
			            if (isMobile) {
				            closeDialog(false);
			            }
		            },
		            visible: permissions.includes("DashboardCategory.View"),
	            },
            ],
        },
    ];


export const managementItems = (
    navigate: (path: string) => void,
    isMobile: boolean,
    closeDialog: (open: boolean) => void,
    permissions: string[],
    t: (key: string) => string,
    activeParent: string | null,
    activeChild: string | null

): MenuItem[] => [
        {
            className: `menu-item ${activeParent === "managementItems" ? "active" : ""}`,
            icon: "pi pi-book",
            items: [
                // From now on only use the grid.
                // {
                //     className: `sub menu-item ${activeChild === "dashboard" ? "active" : ""} ${routeClass("/management/dashboard")}`,
                //     label: t("management.dashboard"),
                //     command: () => {
                //         navigate("/management/dashboard");
                //         if (isMobile) {
                //             closeDialog(false);
                //         }
                //     },
                //     visible: permissions.includes("Dashboard.View"),
                // },
                {
                    className: `sub menu-item ${activeChild === "dashboard-category" ? "active" : ""} ${routeClass("/management/dashboard-category")}`,
                    label: t("management.dashboard-category"),
                    command: () => {
                        navigate("/management/dashboard-category");
                        if (isMobile) {
                            closeDialog(false);
                        }
                    },
                    visible: permissions.includes("DashboardCategory.View"),
                },
            ],
        },
    ];
